export default [
  {
    header: 'Diagnostic',
  }, 	
  {
	 
    title: 'Device',
    icon: 'AirplayIcon',
    children: [
	  {
	    title: 'Device List',
	    route: 'diagnostic-device-list',
		resource: 'ACL',
		action: 'read'
	  },
	  {
	    title: 'Add Device',
	    route: 'diagnostic-device-add',
	  },
	  {
	    title: 'Edit Device',
	    route: { name: 'diagnostic-device-edit', params: { name: 1 } },
		hidden: true,
	  },
    ],
  },
  {
    title: 'Task',
    icon: 'FileTextIcon',
	children: [
	  {
	    title: 'Task List',
	    route: 'diagnostic-task-list',
		resource: 'ACL',
		action: 'read'
	  },
	  {
	    title: 'Add Task',
	    route: 'diagnostic-task-add',
		resource: 'ACL',
		action: 'read'
	  },
	  {
	    title: 'View Task',
	    route: 'diagnostic-task-view',
		hidden: true,
	  	resource: 'ACL',
	  	action: 'read'
	  }	
	]	  
  },
  {
    title: 'Data',
    icon: 'DatabaseIcon',
	children: [
	  {
	    title: 'Data List',
	    route: 'diagnostic-data-list',
		resource: 'ACL',
		action: 'read'
	  } 
	]	  	  
  }
]
